<template>
  <div
    v-if="state"
    class="ais-ToggleRefinement"
    :class="[!state.canRefine && 'ais-ToggleRefinement-noRefinement']"
  >
    <slot
      :value="state.value"
      :can-refine="state.canRefine"
      :refine="state.refine"
      :create-url="state.createUrl"
      :send-event="state.sendEvent"
    >
      <label class="ais-ToggleRefinement-label">
        <input
          class="ais-ToggleRefinement-checkbox"
          type="checkbox"
          :name="state.value.name"
          :value="on"
          :checked="state.value.isRefined"
          @change="state.refine(state.value)"
        >
        <span class="ais-ToggleRefinement-labelText">
          {{ label || state.value.name }}
        </span>
        <span
          v-if="state.value.count !== null"
          class="ais-ToggleRefinement-count"
        >
          {{ state.value.count.toLocaleString() }}
        </span>
      </label>
    </slot>
  </div>
</template>

<script setup>
import { connectToggleRefinement } from 'instantsearch.js/es/connectors'
import { useConnector } from '@/composables'

defineOptions({ name: 'SanToggleRefinement' })
const isSelected = defineModel({ type: Boolean, default: false }) // eslint-disable-line
const props = defineProps({
  attribute: { type: String, required: true },
  label: { type: String, default: undefined },
  on: { type: [String, Number, Boolean, Array], default: true },
  off: { type: [String, Number, Boolean, Array], default: false }
})

const state = useConnector(renderFn => connectToggleRefinement((renderOptions, isFirstRender) => {
  renderFn({
    ...renderOptions
  }, isFirstRender)
}, params => {
  console.log('%cUnmount Toggle Refinement', 'color:orange')
}), {
  $$widgetType: 'ais.toggleRefinement',
  attribute: props.attribute,
  on: props.on,
  off: props.off
})

</script>
